import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useProjectsList } from '../../../contexts/ProjectsContext';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import Header from '../../shared/components/layout/Header';
import Layout from '../components/layout/AppLayout';
import FormInput from '../../shared/components/ui/FormInput';
import AccountsPaymentStagesDetails from './AccountsPaymentStagesDetails';
import Loader from '../../shared/components/ui/Loader';
import Cookies from 'js-cookie';
import mixpanel from 'mixpanel-browser';

const AccountsPaymentStages = () => {
    const userId = Cookies.get('userId');
    const { projectsForDropdown, isProjectsLoading } = useProjectsList();
    const { collapsed } = useSidebar();
    const {
        register,
        setValue,
        watch,
        formState: { errors }
    } = useForm();

    const [selectedProjectId, setSelectedProjectId] = useState(() => {
        const savedProjectId = localStorage.getItem('accountsPaymentStagesSelectedProjectId');
        return savedProjectId ? parseInt(savedProjectId) : null;
    });

    const projectFieldValue = watch('project');

    useEffect(() => {
        mixpanel.track('Accounts Payment Stages Viewed', {
            user_id: userId,
            timestamp: new Date().toISOString()
        });
    }, [userId]);

    useEffect(() => {
        if (projectsForDropdown && projectsForDropdown.length > 0) {
            if (!selectedProjectId) {
                const firstProjectId = projectsForDropdown[0].value;
                setValue('project', firstProjectId);
                setSelectedProjectId(firstProjectId);
                localStorage.setItem('accountsPaymentStagesSelectedProjectId', firstProjectId.toString());
            } else {
                setValue('project', selectedProjectId);
            }
        }
    }, [projectsForDropdown, setValue, selectedProjectId]);

    useEffect(() => {
        if (projectFieldValue && projectFieldValue !== selectedProjectId) {
            const projectId = parseInt(projectFieldValue);
            setSelectedProjectId(projectId);
            localStorage.setItem('accountsPaymentStagesSelectedProjectId', projectId.toString());
        }
    }, [projectFieldValue, selectedProjectId]);

    return (
        <>
            <Loader isVisible={isProjectsLoading} message="Loading projects..." />
            <Layout>
                <div
                    className={`fixed top-0 z-10 transition-all duration-300 ease-in-out bg-white
                        ${collapsed ? 'left-[76px] w-[calc(100%-76px)]' : 'left-64 w-[calc(100%-16rem)]'}
                    `}
                >
                    <Header data={{ name: `Accounts > Payment Stages` }} />
                </div>

                <div
                    className={`flex items-center justify-between px-6 py-4 bg-white fixed top-[4rem] border-t-[2px] border-stone-100 shadow-sm z-[10] transition-all duration-300 ease-in-out ${collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
                        }`}
                >
                    <div className="flex items-center gap-4 w-1/3">
                        <FormInput
                            width={100}
                            label={''}
                            register={register}
                            register_key={'project'}
                            isRequired={true}
                            type={'dropdown'}
                            options={[
                                { label: 'Select Project', value: '', disabled: true },
                                ...projectsForDropdown
                            ]}
                            errors={errors}
                            hideAstrik={true}
                            mb
                        />
                    </div>
                </div>

                <div className="mt-[9rem] h-[calc(100vh-9.5rem)] overflow-auto bg-gray-100">
                    {selectedProjectId ? (
                        <AccountsPaymentStagesDetails projectId={selectedProjectId} />
                    ) : (
                        <div className="flex flex-col items-center justify-center h-full">
                            <h2 className="text-lg font-bold text-gray-800 mb-1">No Project Selected</h2>
                            <p className="text-gray-600 text-sm">Please select a project to view its payment stages.</p>
                        </div>
                    )}
                </div>
            </Layout>
        </>
    );
};

export default AccountsPaymentStages;
